<template>
	<div class="fullWidth">
		<div v-if="paymentInfo.length === 0" class="ordersEmpty">
		<br/>
		<figure class="about-img2 img-wrapper">
			<img src="../assets/static/images/illustrations/deliveryService.svg" />
		</figure>
		<h2>{{ $t('obDeliveries') }}</h2>               
		</div>
		<div v-else class="ordersReceived">
			<v-container class="grey lighten-5">
				<v-row no-gutters>
					<!-- <v-col cols="12" sm="4" md="4">
					<v-card class="pa-2" outlined tile>
						<div>GRAPHS
						</div>
					</v-card>
					</v-col> -->
					<v-col cols="12" sm="12" md="12">
					<v-card class="pa-2" outlined tile>
						<div class="overflow">
							<section v-if="errored">
								<p>{{ $t('fetchError') }}</p>
							</section>
							<section v-else>
								<div v-if="loading">{{ $t('loading') }}</div>

								<div v-else class="container">
									<table class="responsive-table">
										<thead>
										<tr>
											<th scope="col"># {{ $t('status') }} </th>
											<th scope="col"># {{ $tc('order', 2) }} </th>
											<th scope="col">{{ $tc('unit', 1) }}</th>
											<th scope="col">{{ $t('purchasedItem') }}</th>
											<th scope="col">{{ $t('quantity') }}</th>
											<th scope="col">{{ $t('amount') }}</th>
											<th scope="col">{{ $t('userName') }}</th>
											<th scope="col">{{ $t('shippingAddress') }}</th>
											<th scope="col">{{ $t('pickupAddress') }}</th>
											<th scope="col">{{ $t('shippingCost') }}</th>
											<th scope="col">{{ $t('actualPickUpDate') }}</th>
											<th scope="col"></th>
										</tr>
										</thead>
										<tbody>
										<tr
											v-for="(paymentInfo, index) in paymentInfo"
											v-bind:key="paymentInfo">
											<th scope="row">{{ paymentInfo.status }}</th>
											<th scope="row">{{ paymentInfo.id }}</th>
											<td :data-title="$tc('unit', 1)">
											{{ paymentInfo.unit }}
											</td>
											<td :data-title="$t('purchasedItem')">
											<div  v-for="(item, index) in paymentInfo.products" :key="index">
												{{ item.product }}
											</div>
											</td>
											<td :data-title="$t('quantity')">
											<div v-for="(item, index) in paymentInfo.products" :key="index">
												{{ item.quantity }}
											</div>
											</td>
											<td :data-title="$t('amount')">
											{{ paymentInfo.amount }} €
											</td>
											<td :data-title="$t('userName')">
											{{ paymentInfo.userName }}
											</td>
										<td :data-title="$t('shippingAddress')">
											{{ paymentInfo.shippingAddress }}
											</td>
											<td :data-title="$t('pickupAddress')">
											{{ paymentInfo.pickupAddress }}
											</td>
										<td :data-title="$t('shippingCost')">
												{{ paymentInfo.shippingCost }} €
											</td>
											<td :data-title="$t('actualPickUpDate')">
												<a v-if="paymentInfo.prefPickupDate" @click="showDatePicker(index, paymentInfo.estdPickupDate, paymentInfo.prefPickupDate)">{{paymentInfo.prefPickupDate}}</a>
												<v-btn v-else @click="showDatePicker(index, paymentInfo.estdPickupDate)">
													{{ $t('addPreferredPickUpDate') }}
												</v-btn>
												<br/>
												<a v-if="paymentInfo.prefPickupTime" @click="showTimePicker(index, paymentInfo.prefPickupTime)">{{paymentInfo.prefPickupTime}}</a>
												<v-btn v-else @click="showTimePicker(index)">
													{{ $t('addPreferredPickUpTime') }}
												</v-btn>
											</td>
											<td>
						<div v-if="paymentInfo.orderNo">
							{{$t('shippingOrdered')}}
						</div>
						<div v-else>
												<a target="_blank">
							<span v-if="paymentInfo.prefPickupDateTime" @click="putShipmentOrder(paymentInfo)">
								<div class="checkIcon checkIconActive">
								<font-awesome-icon class="icon" icon="check" />
								</div>
								<div class="tipOnHover">{{ $t('orderShipping') }}</div>
							</span>
							<span v-else>
								<div class="checkIcon">
								<font-awesome-icon class="icon" icon="check" />
								</div>
							</span>
												</a>
							</div>
											</td>
										</tr>
										</tbody>
									</table>
									<!---Date$Time picker-->
									<v-dialog
										v-model="selectDate"
										width="500"
										transition="dialog-bottom-transition">
										<v-date-picker
												v-model="pickupDate"
												class="mt-4"
												@change="dateTimeChanged('date')"
												:min="minPickupDate"
												max="2099-12-31">
										</v-date-picker>
									</v-dialog>
									<v-dialog
										v-model="selectTime"
										width="500"
										transition="dialog-bottom-transition">
										<v-time-picker
												v-model="pickupTime"
												:allowed-minutes="allowedStep"
												@click:hour="dateTimeChanged('hour')"
												@click:minute="dateTimeChanged('minute')"
												class="mt-4"
												format="24hr"
												scrollable
											>
										</v-time-picker>
									</v-dialog>
									<!---Date&Time picker-->							
								</div>
							</section>
						</div>
					</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import dateFormat from 'dateformat'
import ShippingService from '@/services/ShippingService.js'

export default {
metaInfo() {
  return {
    title: this.$i18n.tc('delivery', 1),
  }
},
components: {
},
filters: {
  formatDate: function(value) {
    if (value) {
      return moment(String(value)).format('HH:mm:ss DD-MMM-YYYY')
    }
  }
},
data() {
    return {
      isLoading: true,
      paymentInfo: [],
      loading: true,
      errored: false,
      selectDate: false,
      selectTime: false,
      pickupDate: null,
      pickupTime: null,
      rowIndex: null,
      id: this.client.id,  //! sql: "DELETE from clients WHERE id = 'undefined'"
      currentDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      setTime: '10:10',
      minPickupDate: new Date()
    }
},
mounted() {
  this.fetchDeliveryOrders()
},
methods: {
    allowedStep: m => m % 5 === 0,
    fetchDeliveryOrders() {
      axios
      .get(`${process.env.VUE_APP_API_URL}/delivery/order`)
      .then(response => {
          this.paymentInfo = response.data
          this.paymentInfo.forEach(element => {
            if (element.prefPickupDateTime) element.prefPickupDate = moment(String(element.prefPickupDateTime)).format('YYYY-MM-DD')
            if (element.prefPickupDateTime) element.prefPickupTime = moment(String(element.prefPickupDateTime)).format('HH:mm')
          })
      })
      .catch(error => {
          console.log(error)
          this.errored = true
      })
      .finally(() => (this.loading = false)) 
    },
    showDatePicker(index, estdPickupDate, prefPickupDate) {
        this.rowIndex = index
        this.pickupDate = null
        this.minPickupDate = (!estdPickupDate) ? new Date() : new Date(estdPickupDate) 
        this.minPickupDate = moment(String(this.minPickupDate)).format('YYYY-MM-DD')
        if (prefPickupDate) this.pickupDate = prefPickupDate
        this.selectDate = true
    },
  	showTimePicker(index, prefPickupTime) {
        this.rowIndex = index
        this.pickupTime = null
        if (prefPickupTime) this.pickupTime = prefPickupTime
        this.selectTime = true
    },
    async dateTimeChanged(attribute) {
      if (attribute === 'date') {
        this.paymentInfo[this.rowIndex].prefPickupDate = this.pickupDate
        this.selectDate = false
      }

      if (attribute === 'hour' || attribute === 'minute') {
        this.paymentInfo[this.rowIndex].prefPickupTime = this.pickupTime
        if (attribute === 'minute') this.selectTime = false
      }

      if (this.paymentInfo[this.rowIndex].prefPickupDate && this.paymentInfo[this.rowIndex].prefPickupTime) {
        const date = dateFormat(new Date(this.paymentInfo[this.rowIndex].prefPickupDate + ' ' + this.paymentInfo[this.rowIndex].prefPickupTime), 'isoDateTime', true)
        const orderBody = {
          order_id: this.paymentInfo[this.rowIndex].id,
          preferred_pickup_date: date
        }
        await this.$store.dispatch('order/upsertOrder', orderBody)
        this.fetchDeliveryOrders()
      }
    },
    putShipmentOrder(paymentInfo) {
      ShippingService.shipOrder(paymentInfo.cartId, {
        userId: paymentInfo.userId,
        orderId: paymentInfo.id
      }).then(response => {
        alert(this.$t('orderShippingSuccess'))
        this.fetchDeliveryOrders()
        return response.data
      })
      .catch(error => {
        alert(this.$t('tryLater'))
        throw error
      })
    }
    // downloadInvoice() {
    //   if (confirm('you want to download the original invoice?')) {
    //     this.$store
    //       .dispatch('invoice/downloadInvoice', this.id)
    //       // .then(() => {
    //       //   this.$router.push({
    //       //     path: '/products'
    //       //   })
    //       // })
    //       .catch(e => console.log(e))
    //   }
    // }
},
props: {
    client: {
		type: Object,
		default: () => {
        return {}
    }
    }
}
}
</script>

<style lang="scss" scoped>

.ordersEmpty {
  // display: none; //! none when FIRST order with this client_id is already found in db //
}
.ordersReceived {
  // display: none; //! none when NO order with this client_id is found in db //
}

.fullWidth {
	width: 100%;
}

// Breakpoints
$bp-maggie: 15em; 
$bp-lisa: 30em;
$bp-bart: 48em;
$bp-marge: 62em;
$bp-homer: 90em;

// Styles
// * {
//   @include box-sizing(border-box);
  
//   &:before{
//     @include box-sizing(border-box);
//   }
//   &:after {
//     @include box-sizing(border-box);
//   }
// }

// body {
//   font-family: $helvetica;
//   color: rgba(94,93,82,1);
// }

a {
  color: var(--primary);
  
  &:hover,
  &:focus {
    color: var(--primary); 
  }
}

.about-img2 {
  display: inline-block;
  width: 80%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}
.overflow {
		overflow: auto !important;
    	white-space: nowrap !important;
	}

@media only screen and (max-width: 1000px) {
    .responsive-table tbody {
		font-size: 0.4rem;
		display: table;
    	width: 100%;
	}
	::v-deep .v-btn__content {
    font-size: 0.4rem !important;
}
}

@media only screen and (max-width: 750px) {
    .responsive-table tbody {
		font-size: 0.60rem;
		display: table;
    	width: 100%;
	}
	.responsive-table td {
		font-size: 0.70rem;
		padding: 0.1rem !important;
	}
	::v-deep .v-btn__content {
    font-size: 0.3rem !important;
}
.icon {
  margin-right: 7px;
}
}
.container {
  // margin: 5% 3%;
  
  @media (min-width: $bp-homer) {
    // margin: 2em auto;
    // max-width: $bp-homer;
  }
}

.tipOnHover {
  display: none;
}

.checkIcon:hover + .tipOnHover {
  display: block;
  color: var(--bright);
  background-color: var(--bg-light);
  position: absolute;
  z-index: 10;
  right: 58px;
  padding: 3px;
}
.preferredPickUpDateAddBtn {
  color: var(--bright);
  background-color: var(--primaryDark);
  padding: 3px;
}
.dateTimeModal {
	display: absolute;
}

.responsive-table {
  width: 100%;
  margin-bottom: 1.5em;
  border-spacing: 0;
  font-size: 0.75rem !important;
  overflow: auto !important;
  white-space: nowrap !important;
  display: block;
  overflow: scroll;
  white-space: nowrap;


  ::v-deep .v-btn {
    margin-bottom: 5px !important;
}
  ::v-deep .v-btn__content {
    font-size: 0.6rem !important;
}

  
  @media (min-width: $bp-bart) {
    font-size: .9em; 
  }
  
  @media (min-width: $bp-marge) {
    font-size: 1em; 
  }
  
  thead {
    // Accessibly hide <thead> on narrow viewports
    position: absolute;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    padding: 0;
    border: 0;
    height: 1px; 
    width: 1px; 
    overflow: hidden;
    
    @media (min-width: $bp-bart) {
      // Unhide <thead> on wide viewports
      position: relative;
      clip: auto;
      height: auto;
      width: auto;
      overflow: auto;
    }
    
    th {
      background-color: var(--bg-light); 
      border: 1px solid var(--bg-light); 
      font-weight: normal;
      text-align: center;
      color: var(--bright); 
      
      &:first-of-type {
        text-align: left; 
      }
    }
  }

.checkIcon {
  background: var(--grey);
  color: var(--bright);
  padding: 0.3em;
  padding-top: 10px;
  margin-left:auto;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 35px;
  height: 35px;
  right: 0;
  position: relative;
}

.checkIconActive {
  background: var(--primaryDark);
  padding-top: 10px;
  margin-left:auto;
}

.icon {
  font-size: 1.3em;
}
  
  // Set these items to display: block for narrow viewports
  tbody,
  tr,
  th,
  td {
    display: block;
    padding: 0;
    text-align: left;
    white-space: normal;
  }
  
  tr {   
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-row; 
    }
  }
  
  th,
  td {
    padding: .5em;
    vertical-align: middle;
    
    @media (min-width: $bp-lisa) {
      padding: .75em .5em; 
    }
    
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-cell;
      padding: .5em;
    }
    
    @media (min-width: $bp-marge) {
      padding: .75em .5em; 
    }
    
    @media (min-width: $bp-homer) {
      padding: .75em; 
    }
  }
  
  caption {
    margin-bottom: 1em;
    font-size: 1em;
    font-weight: bold;
    text-align: center;
    
    @media (min-width: $bp-bart) {
      font-size: 1.5em;
    }
  }
  
  tfoot {
    font-size: .8em;
    font-style: italic;
    
    @media (min-width: $bp-marge) {
      font-size: .9em;
    }
  }
  
  tbody {
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-row-group; 
    }
    
    tr {
      margin-bottom: 1em;
      
      @media (min-width: $bp-bart) {
        // Undo display: block 
        display: table-row;
        border-width: 1px;
      }
      
      &:last-of-type {
        margin-bottom: 0; 
      }
      
      &:nth-of-type(even) {
        @media (min-width: $bp-bart) {
          background-color: rgba(94,93,82,.1);
        }
      }
    }
    
    th[scope="row"] {
      background-color: var(--bg-light);
      color: white;
      
      @media (min-width: $bp-lisa) {
        border-left: 1px solid  var(--bg-light);
        border-bottom: 1px solid  var(--bg-light);
      }
      
      @media (min-width: $bp-bart) {
        background-color: transparent;
        color: rgba(94,93,82,1);
        text-align: left;
      }
    }
    
    td {
      text-align: right;
      
      @media (min-width: $bp-bart) {
        border-left: 1px solid var(--bg-light); 
        border-bottom: 1px solid  var(--bg-light);
        text-align: center; 
      }
      
      &:last-of-type {
        @media (min-width: $bp-bart) {
          border-right: 1px solid  var(--bg-light);
        } 
      }
    }
    
    td[data-type=currency] {
      text-align: right; 
    }
    
    td[data-title]:before {
      content: attr(data-title);
      float: left;
      font-size: .8em;
      color: rgba(94,93,82,.75);
      
      @media (min-width: $bp-lisa) {
        font-size: .9em; 
      }
      
      @media (min-width: $bp-bart) {
        // Don’t show data-title labels 
        content: none; 
      }
    } 
  }
}

  </style>